import { LoginResponse, PublicSite, toISOString } from "medere-ui-framework";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";

export function useLoginView() {
  const navigate = useNavigate();
  const [welcomeDesc, setWelcomeDesc] = useState('');

  useEffect(() => {
    const appConfig: PublicSite = JSON.parse(localStorage.getItem('siteSettings') ?? "");
    setWelcomeDesc(appConfig.welcomeDesc);
  }, [])

  function settingUserMedereentity(res: LoginResponse, rememberMe: boolean, settingsVersion: string, withNavigation:boolean) { 
    localStorage.setItem("remember", JSON.stringify(rememberMe))
    localStorage.setItem("settings", JSON.stringify({ loginResponse: res, lastRefresh: new Date(), isLogged: true, version: settingsVersion }));
    localStorage.setItem("login", toISOString(new Date()) ?? ""); 
    if(withNavigation) navigate('/dashboard/' + res.user.profile.homepage);
  }

  return { settingUserMedereentity, welcomeDesc };
}